import { forwardRef, type Ref, type SVGProps } from "react";
const IconArrowRightFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M16.38 7.61a2 2 0 0 0 0 2.94L20 14H7a2 2 0 1 0 0 4h13l-3.62 3.45a2 2 0 0 0 0 2.94 2.16 2.16 0 0 0 3 0l7-6.86a2.2 2.2 0 0 0 0-3.06l-7-6.86a2.16 2.16 0 0 0-3 0"
    />
  </svg>
);
const ForwardRef = forwardRef(IconArrowRightFilledSVG);
ForwardRef.displayName = "IconArrowRightFilled";
export { ForwardRef as IconArrowRightFilled };
